import * as React from "react"
import { Dispatch, SetStateAction } from "react"

interface MeetingScheduleProps {
  meetingSelectedOption: { title: string } | undefined
  setMeetingSelectedOption: Dispatch<
    SetStateAction<{ title: string } | undefined>
  >
}
export const MeetingSchedule = ({
  meetingSelectedOption,
  setMeetingSelectedOption,
}: MeetingScheduleProps) => {
  const data = [
    {
      title: "Choose Meeting Schedule",
      options: [
        {
          title: "Daily",
        },
        {
          title: "1 time in a Week",
        },
        {
          title: "2 time in a Week",
        },

        {
          title: "5 time in a Month",
        },
      ],
    },
  ]
  return (
    <div className="mt-10 pt-10 container mx-auto">
      <div className="flex gap-1 justify-center">
        <h2 className="text-black text-3xl font-bold text-center">
          {data[0].title}
        </h2>
        <p className="pt-2 text-black"> (Optional)</p>
      </div>
      <div className="flex justify-center mx-3">
        <form className="flex flex-wrap lg:gap-10 gap-3 items-center mt-10">
          {data[0].options.map((option, index) => (
            <div
              onClick={() =>
                setMeetingSelectedOption(
                  meetingSelectedOption?.title === option.title
                    ? undefined
                    : option
                )
              }
              key={index}
              className="flex gap-2 items-center"
            >
              <div className="border border-[#7B68EC] rounded-full flex items-center p-1">
                <input
                  className="input-radio"
                  type="radio"
                  id={option.title}
                  value={option.title}
                  name="meeting"
                  checked={meetingSelectedOption?.title === option.title}
                  readOnly
                />
              </div>
              <label className="text-black" htmlFor={option.title}>
                {option.title}
              </label>
            </div>
          ))}
        </form>
      </div>
    </div>
  )
}
